import http from '../Http';
import { useEffect, useState, useContext, useRef } from 'react';
import utils from '../utils';
import { Table, Input, Button, DatePicker, Form, Row, Col, Checkbox, Select, Popover } from 'antd';
import { EditOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';
import moment from 'moment';
import Handler from './Handler';
import InputPrefix from '../utils/InputPrefix';
import { useTranslation } from 'react-i18next';



function AlarmManagement(props) {
    const { t, i18n } = useTranslation();
    const setTip = useContext(utils.tipContext);

    const AlarmTypes = {
        1: "Communication Fault",
        2: "Cell Voltage Collect Line Fault",
        3: "Temperature Collect Line Fault",
        4: "Current Collect Line Fault",
        5: "Excessive Cell Voltage Difference",
        6: "Cell Voltage Over",
        7: "Cell Voltage Under",
        8: "Total Voltage Over",
        9: "Total Voltage Under",
        10: "Excessive Charge Temperature Difference",
        11: "Charge Temperature Over",
        12: "Charge Temperature Under",
        13: "Charge Current Over",
        14: "Discharge Current Over",
        15: "SOC Lower",
        16: "Battery Data Collect Abnormal",
        17: "Excessive Total Voltage Difference",
        18: "Pack Capacity Inconsistency",
        19: "Excessive Discharge Temperature Difference",
        20: "Discharge Temperature Over",
        21: "Discharge Temperature Under",
        22: 'MOS Temperature Over',
        23: 'ContactRod Temperature Over',
        24: 'Relay or MOS Sticking',
        25: 'Internal Fault',
        26: "Power Voltage Over",
        27: "Power Voltage Under",
        28: "Insulation Resistance Low",
        29: "Inter-pack Balancing Fault",
        30: "Heating Fault"
    }

    const AlarmTypes2 = [
        t('alarm_communication_fault'),
        t('alarm_cell_voltage_collect_line_fault'),
        t('alarm_temperature_collect_line_fault'),
        t('alarm_current_collect_line_fault'),
        t('alarm_excessive_cell_voltage_difference'),
        t('alarm_cell_voltage_over'),
        t('alarm_cell_voltage_under'),
        t('alarm_total_voltage_over'),
        t('alarm_total_voltage_under'),
        t('alarm_excessive_charge_temperature_difference'),
        t('alarm_charge_temperature_over'),
        t('alarm_charge_temperature_under'),
        t('alarm_charge_current_over'),
        t('alarm_discharge_current_over'),
        t('alarm_soc_lower'),
        t('alarm_battery_data_collect_abnormal'),
        t('alarm_excessive_total_voltage_difference'),
        t('alarm_pack_capacity_inconsistency'),
        t('alarm_excessive_discharge_temperature_difference'),
        t('alarm_discharge_temperature_over'),
        t('alarm_discharge_temperature_under'),
        t('alarm_mos_temperature_over'),
        t('alarm_contactrod_temperature_over'),
        t('alarm_relay_or_mos_sticking'),
        t('alarm_internal_fault'),
        t('alarm_power_voltage_over'),
        t('alarm_power_voltage_under'),
        t('alarm_insulation_resistance_low'),
        t('alarm_inter_pack_balancing_fault'),
        t('alarm_heating_fault')
    ];

    const AlarmTypes3 = {
        1: t('alarm_communication_fault'),
        2: t('alarm_cell_voltage_collect_line_fault'),
        3: t('alarm_temperature_collect_line_fault'),
        4: t('alarm_current_collect_line_fault'),
        5: t('alarm_excessive_cell_voltage_difference'),
        6: t('alarm_cell_voltage_over'),
        7: t('alarm_cell_voltage_under'),
        8: t('alarm_total_voltage_over'),
        9: t('alarm_total_voltage_under'),
        10: t('alarm_excessive_charge_temperature_difference'),
        11: t('alarm_charge_temperature_over'),
        12: t('alarm_charge_temperature_under'),
        13: t('alarm_charge_current_over'),
        14: t('alarm_discharge_current_over'),
        15: t('alarm_soc_lower'),
        16: t('alarm_battery_data_collect_abnormal'),
        17: t('alarm_excessive_total_voltage_difference'),
        18: t('alarm_pack_capacity_inconsistency'),
        19: t('alarm_excessive_discharge_temperature_difference'),
        20: t('alarm_discharge_temperature_over'),
        21: t('alarm_discharge_temperature_under'),
        22: t('alarm_mos_temperature_over'),
        23: t('alarm_contactrod_temperature_over'),
        24: t('alarm_relay_or_mos_sticking'),
        25: t('alarm_internal_fault'),
        26: t('alarm_power_voltage_over'),
        27: t('alarm_power_voltage_under'),
        28: t('alarm_insulation_resistance_low'),
        29: t('alarm_inter_pack_balancing_fault'),
        30: t('alarm_heating_fault'),
    };

    const [pageNo, setPageNo] = useState(0);
    const [pageSize, setPageSize] = useState(25);
    const [params, setParams] = useState({
        SN: '',
        DistributorID: '',
        ProductID: '',
        UserID: '',
        AlarmTypes: '',
        Levels: '',
        Handled: "",
        STime: moment().format("YYYY-MM-DD"),
        ETime: moment().add(1, "days").format("YYYY-MM-DD"),
    });
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [rowTotal, setRowTotal] = useState(0);
    const [tableBodyHeight, setTableBodyHeight] = useState(240);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [showHandler, setShowHandler] = useState(false);
    const [modifyRowIndex, setModifyRowIndex] = useState(null);
    const [productSelectOptions, setProductSelectOptions] = useState([]);
    const [distributorSelectOptions, setDistributorSelectOptions] = useState([]);
    const [expand, setExpand] = useState(false);

    const refTableContainer = useRef();
    const refTimerProductSearcher = useRef(null);
    const refProductSearchValue = useRef(null);
    const refTimerDistributorSearcher = useRef(null);
    const refDistributorSearchValue = useRef(null);

    const [form] = Form.useForm();

    useEffect(() => {
        let active = true;

        (async () => {
            setLoading(true);

            let resp = await http.post("alarm/management/list", {
                PageNo: pageNo,
                PageSize: pageSize,
                Timezone: -(new Date()).getTimezoneOffset() * 60,
                ...params,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[AlarmManagement]", e);
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : "load data error" });

                setRowTotal(0)
                setRows([]);

                return;
            }
            setRowTotal(resp.data.RowTotal);
            setRows(resp.data.Rows);
            setLoading(false);
        })();

        return () => {
            active = false;
        };
    }, [pageNo, pageSize, params]);

    useEffect(() => {
        const el = refTableContainer.current;

        if (el.objResizer) {
            return;
        }

        let obj = document.createElement('object');
        el.objResizer = obj;
        obj.setAttribute('style',
            'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden;opacity: 0; pointer-events: none; z-index: -1;');
        obj.onload = function () {
            setTableBodyHeight(calcTableBodyHeight());

            this.contentDocument.defaultView.addEventListener('resize', (evt) => {
                setTableBodyHeight(calcTableBodyHeight());
            });
        };
        obj.type = 'text/html';
        el.appendChild(obj);
        obj.data = 'about:blank';

        return () => {
            if (!el) {
                return
            }

            //
        }
    }, [refTableContainer.current]);

    const handleSearchProduct = (v) => {
        if (refTimerProductSearcher.current != null) {
            clearTimeout(refTimerProductSearcher.current);
        }
        refProductSearchValue.current = v;

        refTimerProductSearcher.current = setTimeout(async () => {
            const resp = await http.post("product/name/list", {
                Value: v,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[AlarmManagement]", e);
                return null;
            });

            if (refProductSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : "load product list error" });
                    return;
                }

                const ls = resp.data.map(({ Name, ID }) => {
                    return (
                        <Select.Option key={ID} value={ID}>{Name}</Select.Option>
                    );
                });
                setProductSelectOptions(ls);
            } catch (e) {
                console.log("[AlarmManagement]", e);

                setTip({ open: true, severity: "error", msg: "load product list error" });
            }
        }, 300);
    }

    const handleSearchDistributor = (v) => {
        if (refTimerDistributorSearcher.current != null) {
            clearTimeout(refTimerDistributorSearcher.current);
        }
        refDistributorSearchValue.current = v;

        refTimerDistributorSearcher.current = setTimeout(async () => {
            const resp = await http.post("distributor/name/list", {
                Value: v,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[AlarmManagement]", e);
                return null;
            });

            if (refDistributorSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : "load distributor list error" });
                    return;
                }

                const ls = resp.data.map(({ Name, ID }) => {
                    return (
                        <Select.Option key={ID} value={ID}>{Name}</Select.Option>
                    );
                });
                setDistributorSelectOptions(ls);
            } catch (e) {
                console.log("[AlarmManagement]", e);

                setTip({ open: true, severity: "error", msg: "load distributor list error" });
            }
        }, 300);
    }

    const handleSearch = () => {
        setSelectedKeys([]);
        setPageNo(0);

        const ps = form.getFieldsValue();
        let ats = [];
        if (ps.AlarmTypes) {
            ps.AlarmTypes.forEach(type => {
                const index = AlarmTypes2.indexOf(type);
                if (index >= 0) {
                    const alarmType = AlarmTypes[index + 1];
                    if (alarmType) {
                        ats.push(alarmType);
                    }
                }
            });
        }
        ps.SN = ps.SN || "";
        ps.ProductID = ps.ProductID || "";
        ps.DistributorID = ps.DistributorID || "";
        ps.UserID = ps.UserID || "";
        ps.AlarmTypes = ats.join(",");
        ps.STime = ps.DateRange && ps.DateRange.length > 0 ? ps.DateRange[0].format("YYYY-MM-DD") : "";
        ps.ETime = ps.DateRange && ps.DateRange.length > 1 ? moment(ps.DateRange[1]).add(1, "days").format("YYYY-MM-DD") : "";
        ps.Handled = ps.Handled ? (ps.Handled.indexOf("Handled") > -1 && ps.Handled.indexOf("Unhandled") > -1 ? "" : ps.Handled.indexOf("Handled") > -1 ? 1 : 0) : "";
        setParams(ps);
    }

    const renderAction = (v, r, idx) => {
        return (
            <>
                <Button onClick={() => { handleHandle(idx) }} type="link" icon={<EditOutlined size="small" />} />
                {r.LatestHandleTime ? <Popover title={t("Latest Handle Time")} content={r.LatestHandleTime}><br />{t("Latest Handle Time")+": " + r.LatestHandleTime}</Popover> : ""}
            </>
        )
    }

    const handleHandle = (index) => {
        setModifyRowIndex(index);
        setShowHandler(true);
    }

    const handleBatchHandle = () => {
        setShowHandler(true);
    }


    const handleSelect = (selectedRowKeys, selectedRows) => {
        setSelectedKeys([...selectedRowKeys]);
    }

    const handleHandlerClose = (row) => {
        setShowHandler(false);
        setModifyRowIndex(null);

        if (!row) {
            return;
        }

        setSelectedKeys([row.ID]);
        const rw = { ...rows[modifyRowIndex], ...row }
        setRows([...rows.slice(0, modifyRowIndex), rw, ...rows.slice(modifyRowIndex + 1)]);
    }

    const calcTableBodyHeight = () => {
        if (!refTableContainer.current) {
            return 240;
        }

        const hd = document.getElementsByClassName("ant-table-thead")[0];

        const h = refTableContainer.current.getBoundingClientRect().bottom - hd.getBoundingClientRect().bottom;

        return h >= 54 ? h - 54 : h / 2;
    }

    //按下Enter键时进行查找
    const searchByEnter = (e) => {
        if (e.code == "Enter") {
            handleSearch()
        }
    }

    return (
        <div style={{
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            backgroundColor: '#EFF8FE',
            padding: 8,
        }}>
            <div style={{
                flex: "0 1 auto",
            }}>
                <Form
                    form={form}
                    initialValues={{
                        //AlarmTypes: AlarmTypes2,  
                        DateRange: [moment(), moment()],
                        Handled: ["Handled", "Unhandled"]
                    }}
                    style={{
                        padding: 24,
                        background: '#fbfbfb',
                        border: '1px solid #d9d9d9',
                        borderRadius: 2
                    }}
                >
                    <Row gutter={24}>
                        <Col span={8} key="SN">
                            <Form.Item
                                name="SN"
                                label=""
                            >
                                <Input prefix={<InputPrefix label={t('SN')} />} placeholder={t('Enter Device SN')} onPressEnter={handleSearch} style={{ borderRadius: '20px' }} />
                            </Form.Item>
                        </Col>
                        <Col span={8} key="Handled" >
                            <Button type="primary" shape='round' style={{marginRight: '8px'}} onClick={handleSearch}>
                                {t('Search')}
                            </Button>
                            <a onClick={() => setExpand(!expand)}>
                                {expand ? <UpOutlined /> : <DownOutlined />} {expand ? t('Collapse') : t('Expand')}
                            </a>
                            <div style={{width: 8, display: 'inline-block'}}></div>
                            <Form.Item
                                name="Handled"
                                label=""
                                style={{display: 'inline-block'}}
                            >
                                <Checkbox.Group options={[
                                    { label: t('Handled'), value: 'Handled' },
                                    { label: t('Unhandled'), value: 'Unhandled' }
                                ]} />
                            </Form.Item>
                        </Col>
                        <Col span={8} key="DateRange" >
                            <Form.Item
                                name="DateRange"
                                label=""
                            >
                                <DatePicker.RangePicker style={{ borderRadius: '20px' }} />
                            </Form.Item>
                        </Col>
                        <Col span={8} key="ProductID" style={{ display: expand ? "block" : "none" }}>
                            <Input.Group compact>
                                <Button>{t('Product')}</Button>
                                <Form.Item
                                    name="ProductID"
                                    label=""
                                    style={{display: 'inline-block', width: 'calc(100% - 80px)'}}
                                >
                                    <Select
                                        showSearch
                                        placeholder={t('Enter Product Name')}
                                        defaultActiveFirstOption={false}
                                        showArrow={false}
                                        filterOption={false}
                                        onSearch={handleSearchProduct}
                                        onInputKeyDown={searchByEnter}
                                    >{productSelectOptions}</Select>
                                </Form.Item>
                            </Input.Group>
                        </Col>
                        <Col span={8} key="DistributorID" style={{ display: expand ? "block" : "none" }}>
                            <Input.Group compact>
                                <Button>{t('Distributor')}</Button>
                                <Form.Item
                                    name="DistributorID"
                                    label=""
                                    style={{display: 'inline-block', width: 'calc(100% - 100px)'}}
                                >
                                    <Select
                                        showSearch
                                        placeholder={t('Enter Distributor Name')}
                                        defaultActiveFirstOption={false}
                                        showArrow={false}
                                        filterOption={false}
                                        onSearch={handleSearchDistributor}
                                        onInputKeyDown={searchByEnter}
                                    >{distributorSelectOptions}</Select>
                                </Form.Item>
                            </Input.Group>
                        </Col>
                        <Col span={8} key="UserID" style={{ display: expand ? "block" : "none" }}>
                            <Form.Item
                                name="UserID"
                                label=""
                            >
                                <Input prefix={<InputPrefix label={t('UserID')}/>} placeholder={t("Enter User ID")} onPressEnter={handleSearch} style={{ borderRadius: '20px' }} />
                            </Form.Item>
                        </Col>
                        <Col span={24} key="AlarmTypes" style={{ display: expand ? "block" : "none" }}>
                            <Form.Item
                                name="AlarmTypes"
                                label=""
                            >
                                <Checkbox.Group style={{ width: '100%' }}>
                                    <Row gutter={[16, 8]}>
                                        {AlarmTypes2.map((alarmType, index) => (
                                            <Col span={6} key={index}>
                                                <Checkbox value={alarmType}>
                                                    {alarmType}
                                                </Checkbox>
                                            </Col>
                                        ))}
                                    </Row>
                                </Checkbox.Group>
                            </Form.Item>
                        </Col>
                        <Col span={24} key="Levels" style={{ display: expand ? "block" : "none" }}>
                            <Form.Item
                                name="Levels"
                                label=""
                            >
                                <Checkbox.Group style={{ width: '100%' }}>
                                    <Checkbox value="1">{t('Level 1')}</Checkbox>
                                    <Checkbox value="2">{t('Level 2')}</Checkbox>
                                    <Checkbox value="3">{t('Level 3')}</Checkbox>
                                </Checkbox.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'right' }}>
                            <Button
                                shape='round'
                                onClick={() => {
                                    form.resetFields();
                                }}
                            >
                                {t('Clear')}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div style={{
                flex: '0 0 auto',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                paddingTop: 8,
                paddingBottom: 8,
            }}>
                {/* <Button disabled={selectedKeys.length === 1 ? false : true} onClick={handleHandle} type="primary" icon={<EditOutlined />} size="middle" ></Button> */}
                {/* <div style={{ flex: "0 0 20px" }}></div> */}
                {/* <Button disabled={selectedKeys.length > 0 ? false : true} onClick={handleBatchHandle} type="primary" icon={<EditOutlined />} size="middle" >Batch</Button> */}
            </div>
            <div style={{
                flex: "1 1 1px",
                position: "relative",
            }}>
                <div ref={refTableContainer} style={{ position: "absolute", height: '100%', width: "100%", overflow: "hidden" }}>
                    <Table
                        columns={[{
                            title: "",
                            width: 70,
                            fixed: 'left',
                            render: (v, r, idx) => {
                                return (pageNo * pageSize + idx + 1);
                            }
                        }, {
                            title: t('SN'),
                            dataIndex: "SN",
                            width: 200,
                            fixed: 'left',
                            render: (v, r) => {
                                const content = (
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        minWidth: 350,
                                    }}>
                                        <div style={{
                                            display: "flex"
                                        }}>
                                            <div style={{
                                                flex: "0 0 90px",
                                                textAlign: "right",
                                                fontWeight: "bold",
                                            }}>{t('Product')}:&nbsp;</div>
                                            <div style={{ flex: "1" }}>{r.ProductName}</div>
                                        </div>
                                        <div style={{
                                            display: "flex"
                                        }}>
                                            <div style={{
                                                flex: "0 0 90px",
                                                textAlign: "right",
                                                fontWeight: "bold",
                                            }}>{t('Distributor')}:&nbsp;</div>
                                            <div style={{ flex: "1" }}>{r.DistributorName}</div>
                                        </div>
                                        <div style={{
                                            display: "flex"
                                        }}>
                                            <div style={{
                                                flex: "0 0 90px",
                                                textAlign: "right",
                                                fontWeight: "bold",
                                            }}>{t('Users')}:&nbsp;</div>
                                            <div style={{ flex: "1" }}>{r.Users}</div>
                                        </div>
                                    </div>
                                );
                                return (
                                    <Popover title={t('Note')} content={content}>
                                        <div>{v}</div>
                                    </Popover>
                                );
                            }
                        }, {
                            title: t('Name'),
                            dataIndex: "CategoryID",
                            width: 280,
                            render: (v, r, idx) => {
                                return (AlarmTypes3[v] || "") + ( i18n.language != "zh" ? " - Level" + (r["Level"]) : " - " + (r["Level"]) + "级");
                            }
                        }, {
                            title: t('Timezone'),
                            dataIndex: "Timezone",
                            width: 250,
                            render: (v, r, idx) => {
                                var n = parseInt(r["GmtOffset"]);
                                var tz = "UTC+";
                                if (n < 0) {
                                    tz = "UTC-";
                                    n = Math.abs(n);
                                }
                                tz += Math.floor(n / 3600).toString().padStart(2, "0") + ":" + Math.floor((n % 3600) / 60).toString().padStart(2, "0")
                                tz += "(" + v + ")"
                                return tz;
                            }
                        }, {
                            title: t('STime'),
                            dataIndex: "STime",
                            width: 150,
                        }, {
                            title: t('ETime'),
                            dataIndex: "ETime",
                            width: 150,
                        }, {
                            title: t('End User Read'),
                            dataIndex: 'EndUserRead',
                            width: 150,
                            render: (v, r, idx) => {
                                if (r["EndUserReadTime"]) {
                                    return (r["EndUserReadTime"] || "") + ", " + v
                                }
                                return "";
                            }
                        }, {
                            title: t('Action'),
                            key: 'Action',
                            width: 200,
                            render: renderAction,
                        }]}
                        pagination={{
                            pageSizeOptions: [25, 50, 100],
                            current: pageNo + 1,
                            pageSize: pageSize,
                            total: rowTotal,
                            showSizeChanger: true,
                            showTotal: (total) => { return t('Total {{total}}', {total}) },
                            onShowSizeChange: (current, size) => {
                                setPageSize(size);
                            },
                            onChange: (page, pageSize) => {
                                setPageNo(page - 1);
                            }
                        }}
                        tableLayout="fixed"
                        bordered={true}
                        size="middle"
                        loading={loading}
                        rowKey="ID"
                        dataSource={rows}
                        scroll={{ y: tableBodyHeight }}
                        rowSelection={{
                            selectedRowKeys: selectedKeys,
                            onChange: handleSelect,
                            selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE]
                        }}
                    />
                </div>
            </div>
            {showHandler === true ? <Handler row={rows[modifyRowIndex]} AlarmTypes3={AlarmTypes3} show={showHandler} onClose={handleHandlerClose} /> : ""}
        </div>
    );
}

export default AlarmManagement;